import React from "react";

export default function Ex1_Training() {
  return (
    <div>
      <h1>Ex1_Training</h1>
      <p>This is the Ex1_Training component.</p>
    </div>
  );
}
